import { RootState } from 'editor/src/store/index';

const getCurrentSpreadGroup = (state: RootState, spreadIndex = state.editor.currentSpreadIndex) =>
  state.design.designData?.spread_groups?.find((spreadGroup) => spreadGroup.spreadIndexes.includes(spreadIndex));

export default getCurrentSpreadGroup;
